"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const react_resize_detector_1 = require("react-resize-detector");
const EducationBar_1 = __importDefault(require("../../charts/EducationBar"));
const SankeyVertical_1 = __importDefault(require("../../charts/SankeyVertical"));
const model_1 = require("../../charts/SankeyVertical/model");
const ChartWrapper_1 = require("../../components/ChartWrapper");
const Footer_1 = __importDefault(require("../../components/Footer"));
const Footnotes_1 = require("../../components/Footnotes");
const LoadAnimation_1 = __importDefault(require("../../components/LoadAnimation"));
const Sources_1 = require("../../components/Sources");
const Tooltip_1 = __importDefault(require("../../components/Tooltip"));
const utilities_1 = require("../../utilities");
const info_1 = __importDefault(require("./info"));
const settings_1 = require("./settings");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const tooltip_1 = __importDefault(require("./tooltip"));
const barUnitsLookup = {
  'All races': ' of individuals 25+',
  White: ' of white 25+',
  Black: ' of black 25+',
  Hispanic: ' of hispanic 25+',
  Asian: ' of asian 25+'
};
const infoText = {
  hsGradNo: 'Some individuals do not finish high school, others do not enroll',
  colGrad4yrNo: `Those who don't complete college often do so due to affordability and debt`
};
const NODE_HEIGHT = 30;
const LINK_HEIGHT = 50;
const SOTU2021Education = _ref => {
  let {
    titleFontSize = 14,
    title = 'US educational attainment',
    subtitle,
    width
  } = _ref;
  const [sankeyShowingTooltip, setSankeyShowingTooltip] = (0, react_1.useState)(false);
  const [attainmentShowingTooltip, setAttainmentShowingTooltip] = (0, react_1.useState)(false);
  const [dataFetched, setDataFetched] = (0, react_1.useState)(false);
  const [sankeyData, setSankeyData] = (0, react_1.useState)(null);
  const [sankeyError, setSankeyError] = (0, react_1.useState)(null);
  const [attainmentData, setAttainmentData] = (0, react_1.useState)(null);
  const [attainmentError, setAttainmentError] = (0, react_1.useState)(null);
  const [category, setCategory] = (0, react_1.useState)(lodash_1.default.first((0, model_1.getCategories)(settings_1.sankeyLinks)));
  const [date, setDate] = (0, react_1.useState)(null);
  const [hoveredInfo, setHoveredInfo] = (0, react_1.useState)(null);
  const ref = (0, react_1.useRef)();
  const {
    width: containerWidth = width
  } = (0, react_resize_detector_1.useResizeDetector)({
    targetRef: ref,
    refreshMode: 'debounce',
    refreshRate: 250,
    refreshOptions: {
      leading: false,
      trailing: true
    }
  });
  const infoIDs = date ? ['hsGradNo', 'colGrad4yrNo'] : [];
  (0, react_1.useEffect)(() => {
    const linkIDs = (0, lodash_1.default)(settings_1.sankeyLinks).flatMap('metrics').map('id').value();
    const attainmentIDs = (0, lodash_1.default)(settings_1.attainmentBreakdown).flatMap('metrics').map('id').value();
    const url = `https://sotu.usafacts.org/api/v1/metrics?Ids=${[...new Set([...linkIDs, ...attainmentIDs])].join(',')}`;
    window.fetch(url).then(res => res.json()).catch(error => {
      setAttainmentError(`Could not fetch: ${error.toString()}`);
      setSankeyError(`Could not fetch: ${error.toString()}`);
    }).then(metrics => {
      const links = metrics.filter(_ref2 => {
        let {
          id
        } = _ref2;
        return linkIDs.includes(id);
      });
      const attainments = metrics.filter(_ref3 => {
        let {
          id
        } = _ref3;
        return attainmentIDs.includes(id);
      });
      if (links) {
        setSankeyData(links);
        setDate(lodash_1.default.last((0, model_1.getDates)(links)).formatted);
      } else {
        setSankeyError(`Unable to load Sankey. Checks IDs: ${linkIDs.join(',')}`);
      }
      if (attainments) {
        setAttainmentData(attainments);
      } else {
        setAttainmentError(`Unable to load Attainments. Check IDs: ${attainmentIDs.join(',')}`);
      }
    }).finally(() => setDataFetched(true));
  }, []);
  function getInfoPosition() {
    let {
      height,
      width,
      x,
      y
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (lodash_1.default.isFinite(height) && lodash_1.default.isFinite(width) && lodash_1.default.isFinite(x) && lodash_1.default.isFinite(y)) {
      const padding = 9;
      return {
        left: x + width / 2,
        top: y + height + padding + titleFontSize * 1.25
      };
    }
    return {
      left: 0,
      top: 0
    };
  }
  const combinedData = lodash_1.default.concat((0, utilities_1.extractDatasets)(sankeyData), (0, utilities_1.extractDatasets)(attainmentData));
  const {
    sources,
    summary
  } = (0, Sources_1.useSources)({
    data: combinedData
  });
  const {
    footnotes
  } = (0, Footnotes_1.useFootnotes)({
    data: combinedData
  });
  const dataLoaded = sankeyData && sankeyData.length && attainmentData && attainmentData.length;
  const nodesByWidth = containerWidth < 500 ? settings_1.sankeyMobileNodes : settings_1.sankeyNodes;
  const sankeyLayouts = (0, model_1.getLayouts)(sankeyData, settings_1.levels, settings_1.sankeyLinks, settings_1.sankeyMobileNodes, containerWidth, NODE_HEIGHT, LINK_HEIGHT, category, date, 100);
  const infoPositions = infoIDs.map(nodeID => getInfoPosition(lodash_1.default.find(sankeyLayouts.nodes, _ref4 => {
    let {
      id
    } = _ref4;
    return id === nodeID;
  })));
  const sankeyCustomTooltip = (values, category, color, parentValues) => react_1.default.createElement(tooltip_1.default, {
    values: values,
    category: category,
    color: color,
    parentValues: parentValues
  });
  const eduBarCustomTooltip = (values, category, color) => react_1.default.createElement(tooltip_1.default, {
    values: values.map(value => ({
      ...value,
      unit: barUnitsLookup[value.name]
    })),
    category: category,
    color: color
  });
  return react_1.default.createElement("div", {
    className: styles_module_css_1.default['sotu-education']
  }, !dataFetched && !dataLoaded && react_1.default.createElement(LoadAnimation_1.default, null), dataFetched && !dataLoaded && react_1.default.createElement("div", null, react_1.default.createElement("div", null, "Unable to load data"), attainmentError && react_1.default.createElement("div", null, attainmentError), sankeyError && react_1.default.createElement("div", null, sankeyError)), dataFetched && dataLoaded && react_1.default.createElement("div", {
    ref: ref,
    className: "charts-container"
  }, react_1.default.createElement("div", {
    className: `${styles_module_css_1.default['sankey-container']} ${attainmentShowingTooltip ? styles_module_css_1.default.faded : ''}`,
    style: {
      marginBottom: 20
    }
  }, react_1.default.createElement(SankeyVertical_1.default, {
    data: sankeyData,
    hideFooter: true,
    levels: settings_1.levels,
    levelsLabelWidth: 100,
    linkHeight: LINK_HEIGHT,
    links: settings_1.sankeyLinks,
    margins: {
      top: 20,
      left: 0,
      right: 0,
      bottom: 0
    },
    nodeHeight: NODE_HEIGHT,
    nodes: nodesByWidth,
    subtitle: subtitle,
    title: title,
    titleFontSize: titleFontSize,
    tooltipStyle: {
      width: '90%',
      maxWidth: 500
    },
    width: containerWidth,
    categoryCallback: category => {
      setCategory(category);
    },
    customTooltip: sankeyCustomTooltip,
    dateCallback: date => {
      setDate(date);
    },
    hoverCallback: node => {
      setSankeyShowingTooltip(node !== null);
    }
  }), infoPositions.map((position, i) => react_1.default.createElement(info_1.default, {
    key: infoIDs[i],
    ...position,
    onMouseOver: () => {
      setHoveredInfo({
        node: infoIDs[i],
        ...position
      });
    },
    onMouseOut: () => {
      setHoveredInfo(null);
    }
  }))), true && react_1.default.createElement("div", {
    className: `${styles_module_css_1.default['attainment-container']} ${sankeyShowingTooltip ? styles_module_css_1.default.faded : ''}`
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['attainment-info'],
    style: {
      left: 100,
      marginBottom: 20
    }
  }, "Individuals may later graduate college or high school (GED)"), react_1.default.createElement(EducationBar_1.default, {
    barHeight: NODE_HEIGHT,
    breakdown: settings_1.attainmentBreakdown,
    category: category,
    data: attainmentData,
    date: date,
    groups: settings_1.attainmentGroups,
    groupsLabel: "All individuals 25+",
    groupsTitle: "Maximum attainment",
    levelsLabelWidth: 100,
    margins: {
      top: 30,
      left: 0
    },
    showFooter: false,
    tooltipDirection: "above",
    width: containerWidth,
    hoverCallback: node => {
      setAttainmentShowingTooltip(node !== null);
    },
    customTooltip: eduBarCustomTooltip
  })), hoveredInfo && react_1.default.createElement("div", {
    className: styles_module_css_1.default['info-tooltip']
  }, react_1.default.createElement(Tooltip_1.default, {
    x: hoveredInfo.left,
    y: hoveredInfo.top + 20,
    width: containerWidth
  }, react_1.default.createElement("div", null, infoText[hoveredInfo.node]))), react_1.default.createElement(Footer_1.default, {
    sources: sources,
    summary: summary,
    footnotes: footnotes
  })));
};
SOTU2021Education.propTypes = {
  ...ChartWrapper_1.chartWrapperPropTypes,
  // Fallback width in case container has no width
  width: prop_types_1.number
};
exports.default = SOTU2021Education;